module.exports = __webpack_public_path__ + "media/public/images/icon-search-white-a06ae95b518304a2fde968c0eae3b371.svg";